<ng-template #workspaceBody>
    <div class="filter-body">
        @if (visibleSummaries().length) {
            <ul class="filter-summaries" aria-label="Selected filters">
                @for (
                    summary of visibleSummaries();
                    track `${summary.key}:${summary.selectionKey ?? ''}`
                ) {
                    <li class="filter-summary">
                        <span class="filter-summary-copy">
                            <span class="filter-summary-label font-semibold">
                                {{ summary.label }}:
                            </span>
                            <span class="filter-summary-value">
                                {{ summary.value }}
                            </span>
                        </span>
                        <button
                            qpxButton
                            matIconButton
                            size="xs"
                            [attr.aria-label]="summary.clearLabel"
                            (click)="
                                clearSummary(summary.key, summary.selectionKey)
                            "
                        >
                            <ng-icon qpx size="xs" name="lucideX" />
                        </button>
                    </li>
                }
            </ul>
        }

        <div class="filter-content">
            <ng-template [cdkPortalOutlet]="content()" />
        </div>
    </div>
</ng-template>

<ng-template #workspaceActions>
    <button
        qpxButton
        matButton="outlined"
        size="sm"
        [disabled]="!visibleSummaries().length"
        (click)="resetVisibleDraft()"
    >
        <span>Reset</span>
    </button>
    <button
        qpxButton
        matButton="filled"
        size="sm"
        context="primary"
        [disabled]="!controller().isDirty()"
        (click)="apply()"
    >
        <span>Apply filters</span>
    </button>
</ng-template>

@if (appearance() === 'dialog') {
    <qpx-dialog-header
        [title]="triggerLabel()"
        closeLabel="Close filters"
        (dismiss)="dismiss()"
    />

    <qpx-dialog-content contentClass="filter-workspace-dialog-content">
        <ng-container [ngTemplateOutlet]="workspaceBody" />
    </qpx-dialog-content>

    <mat-dialog-actions class="filter-footer">
        <ng-container [ngTemplateOutlet]="workspaceActions" />
    </mat-dialog-actions>
} @else {
    <ng-container [ngTemplateOutlet]="workspaceBody" />

    <footer class="filter-footer">
        <ng-container [ngTemplateOutlet]="workspaceActions" />
    </footer>
}
